<template>
  <div :class="className" :style="{ height: height, width: width, zoom: barzoom }" />
</template>

<script>
import * as echarts from 'echarts';
import { iswindows } from '@/utils/utils';
require('echarts/theme/macarons'); // echarts theme
// import { debounce } from '@/utils'

export default {
  computed: {
    barzoom() {
      let zoom = window.devicePixelRatio;
      // return iswindows() ? zoom : 1;
      return 1;
    },
  },
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '300px',
    },
    bottom: {
      type: String,
      default: '0',
    },
    legendData: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    centerText: {
      type: String,
      default: '',
    },
    colorList:{
      type:Array,
      default:()=>{return ['#00FFFF', '#00FF00', '#FFFF00', '#FF8C00', '#FF0000', '#FE8463']}
    },
  },
  watch: {
    series: {
      deep: true,
      // immediate: true,
      handler(newvalue, oldvalue) {
        if (newvalue) {
          this.initChart();
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    this.__resizeHandler = this._.debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener('resize', this.__resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      let that = this;
      this.chart = echarts.init(this.$el, 'macarons');
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: "#FFF",
          formatter: function (params) {
            return params.data.name + ':' + params.data.value + '人';
          },
        },
        legend: {
          // bottom: this.bottom,
          bottom: that.type=='age'?'40px':'50px',
          left: 'center',
          padding:1,
          itemGap:8,
          itemWidth:8,
          itemHeight:8,
          textStyle:{
            color:'#666',
            fontSize:'10px',
            fontFamily:'PingFangSC-Regular, PingFang SC'
          },
        },
        calculable: true,
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: '30%',
            style: {
              //   text: this.centerText,
              textAlign: 'center',
              fill: '#000',
              fontSize: 14,
            },
          },
        ],
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['36%', '54%'],
            center: ['50%', '32%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '20',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: this.series,
            itemStyle: {
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = that.colorList
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
    },
  },
};
</script>
